import Commander from "./Commander";
import {CONFIG_PARAMS} from "../framework/src/system/SystemConfig";
import * as PIXI from "pixi.js-legacy";
import {SimpleLightmapFilter} from '@pixi/filter-simple-lightmap';
import {pixiSetTimeout, pixiSetTimeoutAsync} from "../framework/src/engine/pixi/pixiTimeout";
import {EASE, getTween, getTweenAsync} from "../framework/src/modules/Tween";
import {getSprite} from "../framework/src/modules/Sprite";
import {calcReal, creditToMoney, moneyToCredit} from "../framework/src/wallet/walletOperations";
import {GAME_EVENTS} from "../framework/src/game/gameEvents";
import events from "../framework/src/events/EventsObservable";
import {numberFormat} from "../framework/src/helpers";

export default class BigWin {

    constructor(commander) {
        this.commander = commander;
        this.Emitter = this.commander.Emitter;
        this.SymbolAnimations = this.commander.SymbolAnimations;
        this.IdleWinAnimations = this.commander.IdleWinAnimations;
        this.audio = this.commander.audio;

        this.numberText = null;
        this.bigWinText = null;

        this.superMegaWin = false;
        this.megaWin = false;
        this.duration = 6;

        this.layer = {
            background: this.commander.layers.background,
            bigwin: this.commander.layers.bigWin,
            reels: this.commander.layers.reels,
            beam: this.commander.layers.win.children[0],
            wild: this.commander.layers.win.children[1],
            anim: this.commander.layers.win.children[2],
            particles: this.commander.layers.win.children[3],
            numbers: this.commander.layers.win.children[4],
            top: this.commander.layers.top,
            win: this.commander.layers.win
        };

        this.filters = {
            colorMatrix: new PIXI.filters.ColorMatrixFilter(),
            colorMatrix2: new PIXI.filters.ColorMatrixFilter(),
            colorMatrix3: new PIXI.filters.ColorMatrixFilter(),
            lightmap : new SimpleLightmapFilter(new PIXI.Texture.from("bigwin_mask_2"), 0xFFFFFF)
        };

        this.wildColor = {brightness: 1, alpha: 0, hue: 0, active: false};
        // this.layer.background.filters = [this.filters.colorMatrix, this.filters.colorMatrix2];

    }

    init() {
        this.layer.bigwin.alpha = 0;

        this.bigWinText = new PIXI.Sprite(PIXI.Texture.from("bigwin"));
        this.bigWinText.position.set(640, 280);
        this.bigWinText.anchor.set(0.5,0.5);
        this.layer.bigwin.addChild(this.bigWinText);

        this.numberText = new PIXI.BitmapText("0", {
            fontName: "font_bigwin-export",
            fontSize: 100,
            tint: 0xFFFFFF,
            align: 'center',
            letterSpacing: 0,
            maxWidth: 1280
        });
        this.numberText.position.set(640, 420);
        this.numberText.scale.set(20,20);
        this.numberText.anchor.set(0.5,0);
        this.numberText.letterSpacing = -20;
        this.layer.bigwin.addChild(this.numberText);

        this.filters.colorMatrix.brightness(1, false);
        this.filters.colorMatrix2.hue(0, false);
        this.filters.colorMatrix.brightness(1, false);
    }

    setDecimalPlaces(win) {
        let creditWin = numberFormat(
            this.commander.wallet.moneyToCreditWithDecimals(win),
            this.commander.wallet.getDecimalPlaces(),
            '.',
            ' '
        )
        this.counterDecimalPlaces = creditWin.split(".")[1].length
        this.commander.wallet.setWinDecimalPlaces(win)
    }

    run(result, wild = false) {
        return new Promise(async res => {
            events.dispatch(GAME_EVENTS.GAME_BIGWIN);
            this.commander.Counter.hide();
            Commander.setAlpha(this.layer.bigwin, 1, 250);
            let lineWins;
            if (wild) {
                lineWins = this.commander.getRespinLineWins(this.commander.respinsIndex, true);
            } else {
                lineWins = BigWin.getLineWins(result);
            }
            this.commander.lineWinsIndex += lineWins.length;
            this.counting = true;
            let win = BigWin.getRespinWin(lineWins);
            this.setDecimalPlaces(win)
            this.setDuration(win);

            this.audio.playTrack("bwin_Start");
            pixiSetTimeout(.5, () => {this.audio.fadeInPlaying("bwin_Bed", 100)});

            this.showWinlines(lineWins);
            this.addText(1);
            this.backgroundShine(wild);
            this.Emitter.bigWinLines(5);
            this.number(win).then(() => {
                Commander.setAlpha(this.layer.bigwin, 0, 250);
                this.hideWinlines(lineWins);
                this.counting = false;
                pixiSetTimeout(0.25, res);
            });
            let i = 0;
            while (this.counting) {
                let lineWin = lineWins[i++%lineWins.length];
                for (let pos of lineWin.position) {
                    let symbol = this.commander.slots.getResultSymbols()[pos[0]*3+pos[1]];
                    await this.SymbolAnimations.run(symbol);
                }
            }
            if (wild) {
                this.changeColor();
            }
            this.commander.wallet.setWinDecimalPlaces(undefined, undefined)
        })
    }

    setDuration(win) {
        win = this.commander.wallet.moneyToCredit(win);
        let bet = this.commander.wallet.getCreditBet();
        let factors = this.getBigWinFactors();
        this.duration = 6;
        if (win >= factors.megaWin*bet) {
            this.duration = 8;
            this.megaWin = true;
        }
        if (win >= factors.superMegaWin*bet) {
            this.duration = 10;
            this.superMegaWin = true;
        }
    }

    /**
     * Creates a sprite of bigwin text. Parameter id defines if it wil be BigWin, MegaWin of SuperMegaWin.
     * Set its position and add it to layer. Create a tween that animates scale and alpha values of sprite.
     * Play sounds on MW and SMW.
     * @param id {number} 1/2/3
     */
    async addText(id) {
        if (this.bigWinText) {
            Commander.removeTween(this.bigWinText);
            this.layer.bigwin.removeChild(this.bigWinText);
        }
        switch(id) {
            case 1:
                this.bigWinText = getSprite("bigwin",640, 300);
                break;
            case 2:
                this.bigWinText.texture = new PIXI.Texture.from("megawin");
                this.audio.playTrack("bwin_MegaWin");
                break;
            case 3:
                this.bigWinText.texture = new PIXI.Texture.from("supermegawin");
                this.audio.playTrack("bwin_SuperMegaWin");
                this.bigWinText.position.set(640, 270);
                break;

        }
        this.bigWinText.alpha = 0;
        this.layer.bigwin.addChild(this.bigWinText);
        getTweenAsync(this.bigWinText,{alpha: 1}, this.duration*25, EASE.LINEAR).then(() => {
            this.shake(this.bigWinText, 100, 10000);
        });
        if (id === 1) {
            this.bigWinText.scale.set(10,10);
            await getTweenAsync(this.bigWinText.scale,{x: 0.9, y: 0.9},250, EASE.QUAD_O);
            await getTweenAsync(this.bigWinText.scale,{x: 1.1, y: 1.1}, this.duration*1000, EASE.QUAD_O);
            await pixiSetTimeoutAsync(1);
            this.audio.playTrack("bwin_End");
            await getTweenAsync(this.bigWinText.scale,{x: 0, y: 0}, 500, EASE.QUAD_I);
        }
    }


    backgroundShine(wild) {
        this.applyFilters();
        this.tweenBrightnessHue(wild).then(() => {
            if (!wild)
                this.removeFilters();
        });
    }

    number(win) {
        return new Promise(res => {
            this.audio.playTrack("bwin_Counter");
            this.audio.playTrack("ui_Counter");

            let credit = this.commander.wallet.moneyToCredit(win);
            let initWin = this.commander.wallet.getWin();

            let obj = {credit: 0, win: 0};
            let factors = this.getBigWinFactors();
            let bet = this.commander.wallet.getCreditBet();

            Commander.setAlpha(this.numberText, 1, 150);
            createjs.Tween.get(this.numberText.scale)
                .wait(250)
                .to({x: 1, y: 1},250, createjs.Ease.quadOut)
                .to({x: 1.3, y: 1.3},this.duration*1000, createjs.Ease.quadOut)
                .to({x: 1.2, y: 1.2},250, createjs.Ease.quadIn)
                .to({x: 1.4, y: 1.4},250, createjs.Ease.quadIn)
                .to({x: 1.2, y: 1.2},250, createjs.Ease.quadIn)
                .to({x: 1.4, y: 1.4},250, createjs.Ease.quadIn)
                .to({x: 0, y: 0}, 500, createjs.Ease.quadIn)
                .call(res);

            createjs.Tween.get(obj)
                .to({credit: credit, win: win}, this.duration*1100, createjs.Ease.linear)
                .call(() => {
                    this.audio.stopTrack("bwin_Counter");
                    this.audio.stopTrack("ui_Counter");
                    this.audio.playTrack("ui_Counter_Stop");
                    this.audio.playTrack("bwin_Counter_Stop");
                    this.audio.stopTrack("bwin_Bed");
                })
                .wait(1000)
                .addEventListener("change", () => {
                    let n = obj.credit
                    this.numberText.text = numberFormat(
                        obj.credit,
                        this.commander.wallet.getCreditWinDecimalPlaces(),
                        '.',
                        ' '
                    )
                    if (n >= factors.superMegaWin*bet) {
                        if (this.superMegaWin) {
                            this.addText(3);
                            this.superMegaWin = false;
                        }
                    } else if (n >= factors.megaWin*bet) {
                        if (this.megaWin) {
                            this.addText(2);
                            this.megaWin = false;
                        }
                    }
                    this.commander.setWin(Math.round(obj.win)+initWin);
                });

        });
    }

    // returns array of lineWins, always the ones from the last respin
    static getLineWins(result) {
        let lineWins = [];

        for (let lineWin of result.lineWins) {
            if (lineWin.type === "spread" || lineWin.type === "respin") {
                lineWins = [];
                continue;
            }
            lineWins.push(lineWin);
        }
        return lineWins;
    }

    static getRespinWin(lineWins) {
        let win = 0;
        for (let lineWin of lineWins) {
            win += lineWin.win;
        }
        return win;
    }

    getBigWinFactors() {
        return {
            bigWin: this.commander.config.get(CONFIG_PARAMS.BIG_WIN_FACTOR),
            megaWin: this.commander.config.get(CONFIG_PARAMS.MEGA_WIN_FACTOR),
            superMegaWin: this.commander.config.get(CONFIG_PARAMS.SUPER_WIN_FACTOR)
        }
    }

    hideWinlines(lineWins) {
        for (let lineWin of lineWins) {
            if (this.IdleWinAnimations.winLines[lineWin.line].visible) {
                this.IdleWinAnimations.hideIdleWinLine(lineWin.line+1);
            }
        }
    }

    showWinlines(lineWins) {
        for (let lineWin of lineWins) {
            if (!this.IdleWinAnimations.winLines[lineWin.line].visible) {
                this.IdleWinAnimations.showIdleWinLine(lineWin.line+1);
            }
        }
    }

    tweenBrightnessHue(wild) {
        return new Promise(res => {
            let power = 5;
            let obj = {brightness: 1, hue: 0, alpha: 0.6};
            if (wild)
                obj = {brightness: this.wildColor.brightness, hue: this.wildColor.hue , alpha: this.wildColor.alpha};

            createjs.Tween.get(obj)
                .to({brightness: power, hue: 360, alpha: 0}, this.duration*200, createjs.Ease.cubicIn)
                .call(() => {
                    this.commander.layers.reels.filters = [this.filters.colorMatrix3];
                    this.commander.layers.win.filters = [this.filters.colorMatrix3];
                })

                .to({brightness: 2*power, hue: 720}, this.duration * 500, createjs.Ease.linear)
                .to({brightness: power, hue: 360}, this.duration * 250, createjs.Ease.linear)
                .to({brightness: .5*power, hue: 180}, this.duration *200, createjs.Ease.linear)
                .call(() => {
                    this.commander.layers.reels.filters = [];
                    this.commander.layers.win.filters = [];
                })
                .to({brightness: this.wildColor.brightness, hue: this.wildColor.hue, alpha: this.wildColor.alpha}, this.duration *100, createjs.Ease.linear)
                .call(() => {
                    this.clearAnim();
                    Commander.removeTween(obj);
                    res();
                })
                .addEventListener("change", () => {
                    this.filters.lightmap.alpha = obj.alpha;
                    this.filters.colorMatrix.brightness(obj.brightness, false);
                    this.filters.colorMatrix2.hue(obj.hue, false);

                    this.filters.colorMatrix3.brightness((obj.brightness/8 < 1) ? 1: obj.brightness/8, false);
                });

        });
    }

    clearAnim() {
        this.filters.colorMatrix.brightness(1, false);
        this.filters.colorMatrix2.hue(0, false);
        this.filters.colorMatrix.brightness(1, false);
        this.layer.background.filters = [this.filters.lightmap, this.filters.colorMatrix, this.filters.colorMatrix2];
        //Commander.setAlpha(this.layer.winLines, 1, 0);
        Commander.setAlpha(this.layer.win, 1, 0);
        Commander.setAlpha(this.layer.reels, 1, 0);
        this.Emitter.cleanUp();
    }

    applyFilters() {
        this.layer.reels.filters.push(this.SymbolAnimations.filter, this.filters.colorMatrix3);
        this.layer.win.filters = [this.filters.colorMatrix3];
        this.layer.background.filters = [this.filters.lightmap, this.filters.colorMatrix, this.filters.colorMatrix2];
        this.bigWinText.filters = [this.filters.colorMatrix2];
    }

    removeFilters() {
        this.layer.reels.filters = [this.SymbolAnimations.filter];
        this.layer.win.filters = [];
        this.bigWinText.filters = [];
        this.layer.background.filters = [];
    }


    changeColor() {
        this.layer.background.filters = [this.filters.lightmap, this.filters.colorMatrix, this.filters.colorMatrix2];
        createjs.Tween.get(this.wildColor)
            .to({brightness: 10, hue: 100, alpha: 0.1, active: true}, 1000, createjs.Ease.cubicIn)
            .call(() => {
                Commander.removeTween(this.wildColor);
                this.loopColor();
            })
            .addEventListener("change", () => {
                this.filters.lightmap.alpha = this.wildColor.alpha;
                this.filters.colorMatrix.brightness(this.wildColor.brightness, false);
                this.filters.colorMatrix2.hue(this.wildColor.hue, false);
                this.filters.colorMatrix3.brightness(this.wildColor.brightness/8+1, false);
            });

    }

    loopColor() {

        createjs.Tween.get(this.wildColor, {loop:true})
            .to({brightness: 10}, 250)
            .to({brightness: 12}, 500)
            .to({brightness: 10}, 250)
            .addEventListener("change", () => {
                this.filters.lightmap.alpha = this.wildColor.alpha;
                this.filters.colorMatrix.brightness(this.wildColor.brightness, false);
                this.filters.colorMatrix2.hue(this.wildColor.hue, false);
                this.filters.colorMatrix3.brightness(this.wildColor.brightness/8+1, false);
            });
    }

    removeColor() {

        if(!this.wildColor.active) return;

        Commander.removeTween(this.wildColor);
        this.audio.playTrack("bonus_Wild_End");
        this.wildColor.active = false;
        createjs.Tween.get(this.wildColor)
            .to({brightness: 1, hue: 0, alpha: 1.0}, 750, createjs.Ease.cubicOut)
            .call(() => {
                Commander.removeTween(this.wildColor);
                this.removeFilters();
            })
            .addEventListener("change", () => {
                this.filters.lightmap.alpha = this.wildColor.alpha;
                this.filters.colorMatrix.brightness(this.wildColor.brightness, false);
                this.filters.colorMatrix2.hue(this.wildColor.hue, false);
                this.filters.colorMatrix3.brightness(this.wildColor.brightness/8+1, false);
            });
    }

    async shake(obj, count, time) {
        let x = obj.x;
        let y = obj.y;
        let power = Math.random() % 2 ? 1 / 3 : -1 / 3;
        for (let i = 0; i < count; i++) {
            await Commander.getTweenAsync(obj, {
                x: x + (power * 5),
                y: y + ((Math.random() * 10 - 5) * power)
            }, (time / count) / 2);
            // if last loop, return symbol to init position
            await Commander.getTweenAsync(obj, {
                x: i === count-1 ? x : x - (power * 5),
                y: i === count-1 ? y : y - ((Math.random() * 10 - 5) * power)
            }, (time / count) / 2);
        }
    }

}
